export default __webpack_public_path__ + "static/download_pdf@2x-893e34757503ae2df51988e6bf1027b7.png";